import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminSettings } from '../components/AdminSettings';

export const Route = createFileRoute('/admin-settings/project-hours')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!user || user.role !== 'admin') {
      throw redirect({
        to: '/time-entry',
      });
    }
  },
  component: AdminSettingsComponent,
});

function AdminSettingsComponent() {
  return <AdminSettings />;
}
